import {
  Component,
  OnInit,
  Input,
  ElementRef,
  ViewChildren,
  HostListener
} from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormArray,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormBuilder,
  NG_VALIDATORS,
  Validators,
  Validator,
  NgForm,
  CheckboxControlValueAccessor
} from "@angular/forms";
import * as postalCode from 'japan-postal-code'
import { CustomValidators } from "../../directives/custom-validator.directive";
import { logbaseService } from "../../services/logbase.service";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { formService } from "../../services/form.service";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { formDialogService } from "../../services/formDialogService";
import { dataService } from "../../services/data.service";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { Calendar } from "primeng/calendar";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { EMPTY as empty, zip } from "rxjs";

interface zipCode {
  area?: string; // the "?" makes the property optional,
  city?: string; //  so you can start with an empty object
  prefecture?: string; // the "?" makes the property optional,
  street?: string; //  so you can start with an empty object
}

@Component({
  selector: "app-supply-info",
  templateUrl: "./supply-info.component.html",
  styleUrls: ["./supply-info.component.scss"]
})
export class SupplyInfoComponent implements OnInit {
  AdminDisableBtn: boolean;
  zipValid: boolean;
  postalCode: any;
  noZipValue: boolean;
  noValue: boolean;
  zipCodeSupply: any;
  zipCode: any;
  supplierNameJP: any;
  supplierNameEng: any;
  copiedPartInfo: any;
  partDataFor: any;
  supplyJapanSelected: boolean;
  disableSubmit: boolean;
  japanSelected: boolean;
  country: string[] = [];
  displayOverallStatus: string;
  overAllPackageIDStatus: any;
  navigateAfterSave: boolean = true;
  userRoleName: any;
  loginId: any;
  shippingList = [];
  contractEdit: boolean;
  transportModeEdit: boolean;
  regionEdit: boolean;
  shippingStreetEdit: boolean;
  shippingZipEdit: boolean;
  shippingCityEdit: boolean;
  shippingPrefectureEdit: boolean;
  shippingCountryEdit: boolean;
  productionStreetEdit: boolean;
  productionZipEdit: boolean;
  productionCityEdit: boolean;
  productionPrefectureEdit: boolean;
  productionCountryEdit: boolean;
  partLSData: any;
  supplyInfoResult: any;
  userRoleId: any;
  serviceProviderNames: any[];
  contractTypeOption: any = "";
  globalInfoData: any = null;
  supplierInfoData: any = null;
  supplyInfoData: any = null;
  supplyCounter: number = 0;
  city: string = "Tokyo";
  cityOpt: string[] = ["Tokyo", "Frankfurt", "Bangalore"];
  supplySpNameOpt: string[] = [
    "MLT",
    "Nittsu(日通)",
    "Ootomo(大友)",
    "Others(その他)"
  ];
  asl: string = "Yes";
  aslOpt: string[] = ["Yes(はい)", "No(いいえ)"];

  region: string = "North";
  regionOpt: string[] = ["North", "West", "Central"];

  transport: string = "LTF";
  transportOpt: string[] = ["FTL", "LTL", "MR"];
  transportModeRequired: boolean = true;

  contract: string = "Fuso Paid";
  contractOpt: string[] = ["Fuso-Paid", "Supplier-paid"];

  supplyTimeOpt: string[] = [
    "08:00 - 10:00",
    "10:00 - 12:00",
    "12:00 - 15:00",
    "15:00 - 17:00"
  ];
  supplyDeliveryOpt: string[] = [
    "08:00 - 10:00",
    "10:00 - 12:00",
    "12:00 - 15:00",
    "15:00 - 17:00"
  ];
  zipPattern: any = "";
  supplyInfoForm: FormGroup;
  partApiData: any;
  routePackageID: any;
  partData: any;
  parts: any;
  notvalid = [true, true, true];
  private jsonFileURL: string = "assets/countries.json";
  @ViewChildren(Calendar)
  public cals: Calendar[];
  zipDetailsAddress: any; // initializing with an empty object
  regex = /^\d{3}-\d{4}$/;
  detailsAddress = [
    { supplyCity: "", supplyAddress: "", supplyStreet: "", error: false },
    { supplyCity: "", supplyAddress: "", supplyStreet: "", error: false },
    { supplyCity: "", supplyAddress: "", supplyStreet: "", error: false }
  ];
  packageID: string;

  constructor(
    private form: FormBuilder,
    private logbaseService: logbaseService,
    private modalService: NgbModal,
    private http: HttpClient,
    private formService: formService,
    private toastr: ToastrService,
    private formDialogService: formDialogService,
    private dataService: dataService,
    private route: ActivatedRoute,
    private router: Router,
    private el: ElementRef,
    private translate: TranslateService,
    private spinner: NgxSpinnerService
  ) {
    localStorage.removeItem("address");
    localStorage.removeItem("address0");
    localStorage.removeItem("address1");
    localStorage.removeItem("address2");
  }

  ngOnInit() {
    this.spinner.show();
    this.AdminDisableBtn = false;
    this.router.events.subscribe(evt => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
    this.http.get(this.jsonFileURL).subscribe((result:string[]) => {
      //test the result format
      //this.country = result.json();
      this.country=result
    });
    // Get package id to get all other details
   
    if(!this.route.snapshot.params["id"])
    {
      this.routePackageID =localStorage.getItem("packageID")
    }
    else
    {
    this.routePackageID = this.route.snapshot.params["id"];
    localStorage.setItem("packageID", this.routePackageID);
    }
    console.log("routerpackage id",this.routePackageID)

    this.logbaseService.getServiceProviders().subscribe(result => {
      if (result.status.statusMessage == "SUCCESS") {
        let serviceProviders: any[] = result.response;
        this.serviceProviderNames = serviceProviders.map(
          obj =>
            obj.serviceProvider +
            (obj.serviceProviderJp != "" &&
            obj.serviceProviderJp != undefined &&
            obj.serviceProviderJp != null
              ? "(" + obj.serviceProviderJp + ")"
              : "")
        );

        console.log(this.serviceProviderNames);
      }
    });

    this.logbaseService
      .getNewPartsbyPkgId(this.routePackageID)
      .subscribe(result => {
        this.overAllPackageIDStatus = result.response.ovarAllPackageIDStatus;

        //Get parts data from URL and bind in form fields
        this.partData = result.response;
        console.log("partdata",this.partData)

        // Get Parts Information form data which is already saved
        this.getSupplyInfoById(this.partData);

        // to disable save, next & submit button if user already preformed their corresponding actions
        this.disableCheck(this.partData);

        // Get supplier name
        this.getSupplierName(this.partData);

        if (this.overAllPackageIDStatus == "new") {
          this.displayOverallStatus = "New";
        } else if (this.overAllPackageIDStatus == "inProgress") {
          this.displayOverallStatus = "In Progress";
        } else if (this.overAllPackageIDStatus == "approved") {
          this.displayOverallStatus = "Approved";
        } else if (this.overAllPackageIDStatus == "rejected") {
          this.displayOverallStatus = "Rejected";
        } else if (this.overAllPackageIDStatus == "underReview") {
          this.displayOverallStatus = "Under Review";
        } else if (this.overAllPackageIDStatus == "approvedAndClosed") {
          this.displayOverallStatus = "Approved & Closed";
        }
      });

    // Get user role based on user login stored in local storage
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    this.userRoleId = userDetJson.userRoleMappings[0].roleId;
    this.userRoleName = userDetJson.userRoleMappings[0].roleName;
    this.loginId = userDetJson.loginId;

    // Not allow supplier to edit the information until it get approved / rejected from SM, logistics, Operation
    if (this.overAllPackageIDStatus == "underReview" && this.userRoleId == 1) {
      this.toastr.warning(
        "Package currently in under review status, Please check back once it is approved / rejected"
      );
      this.router.navigate(["/dashboard"]);
    }

    this.checkFieldAccess();
    this.createFormControls();

    // if (this.supplyInfoForm.controls.supplierCountry.value == "" || this.supplyInfoForm.controls.supplierCountry.value == null) {
    //   this.noValue = true
    // }
   // this.productionZipcode();
    //  this.setValidatorForTransportMode();
    //  this.sendSupplyFormData();
    this.checkSupplyContract();
    
  }

  ngAfterViewInit() {
    this.cals.forEach(calendar => {
      let elem = calendar.inputfieldViewChild.nativeElement;
      elem.addEventListener("click", () => {
        let el = document.querySelector(".ui-hour-picker a");
        el.removeAttribute("href");
        el.setAttribute("data-target", "#");
      });
    });
  }

  productionZipcode() {
    let pattern = new RegExp("^[0-9]{3}[\-]?[0-9]{4}$")
    this.supplyInfoForm
      .get("supplierCountry")
      .valueChanges.subscribe((country: string) => {
        if (country == "Japan") {
          this.supplyInfoForm
            .get("japanZipcode")
            .setValidators([Validators.pattern(pattern)]);
          this.japanSelected = true;
          this.noValue = false;
        } else if (country != "Japan" && country != undefined) {
          // this.supplyInfoForm.get("japanZipcode").setValue = null;
          this.supplyInfoForm
            .get("japanZipcode")
            .setValidators([Validators.pattern(pattern)]);
          this.japanSelected = false;
          this.noValue = false;
        } else if (country == null || country == undefined) {
          this.noValue = true;
        }
        this.supplyInfoForm.get("japanZipcode").updateValueAndValidity();
      });
  }

  checkSupplyContract() {
    this.supplyInfoForm.get("supplyContract").valueChanges.subscribe(value => {
      if (value === "Supplier-paid") {
        this.supplyInfoForm.controls["supplyRegion"].disable();
        this.transportModeRequired = false;
      } else if (value === "Fuso-Paid") {
        this.supplyInfoForm.controls["supplyRegion"].enable();
        // this.translate.use('jn')
        this.transportModeRequired = true;
        this.translate.get(this.zipDetailsAddress).subscribe((res: string) => {
          console.log(res);
        });
        this.getPrefectureRegion(this.zipDetailsAddress);
      } else {
        this.supplyInfoForm.controls["supplyRegion"].enable();
        this.transportModeRequired = true;
      }
    });
  }

  getPrefectureRegion(prefecture) {
    console.log(prefecture);
    this.spinner.show();
    this.logbaseService.getOnePrefecture(prefecture).subscribe(
      response => {
        const prefecData = response;
        console.log(prefecData);
        
        // if (
        //   prefecData.status.statusMessage === "SUCCESS" &&
        //   prefecData.status.statusCode === 1 &&
        //   prefecData.response !== "Response is empty"
        // ) {
        //   this.spinner.hide();
        // } else {
        // }
        // // console.log(prefecData.status);
      },
      error => {
        this.spinner.hide();
      }
    );
    this.spinner.hide();
  }

  // @HostListener("window:beforeunload", ["$event"])
  // public beforeunloadHandler($event) {
  //   $event.returnValue = "Are you sure?";
  //   this.packageID = localStorage.getItem('packageID')
  //   if (confirm("Are you sure you want to leave this page?")) {
  //     return true;
  //   } else {
  //     this.lockUnlockPackage(this.packageID);
  //     return false;
  //   }
  // }

  // lockUnlockPackage(packageID) {
  //   let dataToSend = {
  //     pkgStatus: "ENABLE",
  //     pkgId: packageID
  //   }
  //   this.logbaseService.packageLockUnlock(dataToSend).subscribe(result => {
  //   });
  // }

  disableCheck(partData) {
    // Get user role based on user login stored in local storage
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    let loggedinSuppCode = userDetJson.supplierCode;
    let loggedinLineNo = userDetJson.lineNumbers;
    let loggedInopMgrSupplierCode = userDetJson.operationManagerSupplierCode;
    let loggedInopMgrDeliveryPoint =
      userDetJson.operationManagerdeliveryPointMaster;

    if (this.userRoleId == 4) {
      if (loggedinLineNo != null) {
        var findLineNo = loggedinLineNo.find(
          x => x == this.partData.lineNumber
        );
        var findOMSupCode = loggedInopMgrSupplierCode.find(
          x => x == this.partData.supplierCode
        );
        var findOMDelPoint = loggedInopMgrDeliveryPoint.find(
          x => x == this.partData.deliveryPoint
        );
      }
      findSuppCode = "";
    } else {
      if (loggedinSuppCode != null) {
        var findSuppCode = loggedinSuppCode.find(
          x => x == this.partData.supplierCode
        );
      }
      findLineNo = "";
    }

    if (findSuppCode == undefined) {
      this.supplyInfoForm.disable();
      this.disableSubmit = true;
    } else if (findLineNo == undefined && findOMDelPoint == undefined) {
      this.supplyInfoForm.disable();
      this.disableSubmit = true;
    } else {
      if (this.userRoleId == 5) {
        this.supplyInfoForm.disable();
        this.AdminDisableBtn = true;
        this.disableSubmit = true;
      }
      if (this.userRoleId == 1) {
        if (
          this.overAllPackageIDStatus == "approvedAndClosed" ||
          this.overAllPackageIDStatus == "rejectedAndClosed" ||
          this.overAllPackageIDStatus == "underReview"
        ) {
          this.disableSubmit = true;
        }
      } else if (this.userRoleId == 2) {
        if (
          this.overAllPackageIDStatus == "new" ||
          this.overAllPackageIDStatus == "inProgress" ||
          this.overAllPackageIDStatus != "underReview" ||
          (this.overAllPackageIDStatus == "underReview" &&
            (partData.supplierManagerStatus == "approved" ||
              partData.supplierManagerStatus == "rejected"))
        ) {
          this.disableSubmit = true;
        }
      } else if (this.userRoleId == 3) {
        if (
          this.overAllPackageIDStatus == "new" ||
          this.overAllPackageIDStatus == "inProgress" ||
          this.overAllPackageIDStatus != "underReview" ||
          (this.overAllPackageIDStatus == "underReview" &&
            (partData.logisticStatus == "approved" ||
              partData.logisticStatus == "rejected"))
        ) {
          this.disableSubmit = true;
        }
      } else if (this.userRoleId == 4) {
        if (
          this.overAllPackageIDStatus == "new" ||
          this.overAllPackageIDStatus == "inProgress" ||
          this.overAllPackageIDStatus != "underReview" ||
          (this.overAllPackageIDStatus == "underReview" &&
            (partData.operatorStatus == "approved" ||
              partData.operatorStatus == "rejected"))
        ) {
          this.disableSubmit = true;
        }
      } else if (this.userRoleId == 7) {
        if (
          this.overAllPackageIDStatus == "new" ||
          this.overAllPackageIDStatus == "inProgress" ||
          this.overAllPackageIDStatus != "underReview" ||
          (this.overAllPackageIDStatus == "underReview" &&
            (partData.supplierManagerVSStatus == "approved" ||
              partData.supplierManagerVSStatus == "rejected"))
        ) {
          this.disableSubmit = true;
        }
      } else if (this.userRoleId == 9) {
        if (
          this.overAllPackageIDStatus == "approved" ||
          this.overAllPackageIDStatus == "rejected"
        ) {
          this.disableSubmit = true;
        }
      }
    }
    if (this.userRoleId == 15) {
      this.AdminDisableBtn = true;
    }
  }

  getSupplierName(partData) {
    this.spinner.show();
    let suppCode = partData.supplierCode;
    this.logbaseService.fetchSupplierName(suppCode).subscribe(result => {
      this.supplierNameEng = result.response.supplierNameEN;
      this.supplierNameJP = result.response.supplierNameJP;
      this.supplyInfoForm.patchValue({
        supplierNameEng: result.response.supplierNameEN,
        supplierNameJP: result.response.supplierNameJP
      });
    });
     this.spinner.hide();
  }

  selectedSupplyCountry(val: any) {
    // this.supplyJapanSelected = false
    if (val == "Japan") {
      this.supplyJapanSelected = true;
      this.noZipValue = false;
    } else if (val != "Japan" && val != "") {
      this.supplyJapanSelected = false;
      this.noZipValue = false;
    } else if (val == "") {
      this.supplyJapanSelected = false;
      this.noZipValue = true;
    }
  }

  checkFieldAccess() {
    if (this.userRoleId == 1 || this.userRoleId == 9) {
      this.productionCountryEdit = false;
      this.productionPrefectureEdit = false;
      this.productionCityEdit = false;
      this.productionZipEdit = false;
      this.productionStreetEdit = false;
      this.shippingCountryEdit = false;
      this.shippingPrefectureEdit = false;
      this.shippingCityEdit = false;
      this.shippingZipEdit = false;
      this.shippingStreetEdit = false;
      this.regionEdit = true;
      this.transportModeEdit = true;
      this.contractEdit = true;
    } else if (this.userRoleId == 2 || this.userRoleId == 7) {
      this.productionCountryEdit = false;
      this.productionPrefectureEdit = false;
      this.productionCityEdit = false;
      this.productionZipEdit = false;
      this.productionStreetEdit = false;
      this.shippingCountryEdit = false;
      this.shippingPrefectureEdit = false;
      this.shippingCityEdit = false;
      this.shippingZipEdit = false;
      this.shippingStreetEdit = false;
      this.regionEdit = true;
      this.transportModeEdit = true;
      this.contractEdit = true;
    } else if (this.userRoleId == 3) {
      this.productionCountryEdit = true;
      this.productionPrefectureEdit = true;
      this.productionCityEdit = true;
      this.productionZipEdit = true;
      this.productionStreetEdit = true;
      this.shippingCountryEdit = true;
      this.shippingPrefectureEdit = true;
      this.shippingCityEdit = true;
      this.shippingZipEdit = true;
      this.shippingStreetEdit = true;
      this.regionEdit = false;
      this.transportModeEdit = false;
      this.contractEdit = false;
    } else if (this.userRoleId == 4) {
      this.productionCountryEdit = true;
      this.productionPrefectureEdit = true;
      this.productionCityEdit = true;
      this.productionZipEdit = true;
      this.productionStreetEdit = true;
      this.shippingCountryEdit = true;
      this.shippingPrefectureEdit = true;
      this.shippingCityEdit = true;
      this.shippingZipEdit = true;
      this.shippingStreetEdit = true;
      this.regionEdit = true;
      this.transportModeEdit = true;
      this.contractEdit = true;
    }
  }

  getSupplyInfoById(partData) {
    this.spinner.show();

    let localPartData = localStorage.getItem("copiedPart");
    console.log("local part data",localPartData)
    if (localPartData) {
      if (localPartData != "undefined") {
        let copiedPart = JSON.parse(localPartData);

        if (copiedPart.currentPart == this.routePackageID) {
          if (copiedPart.supplyInfoSave == 1) {
            this.partDataFor = this.routePackageID;
          } else {
            this.partDataFor = copiedPart.copyPart;
          }
        } else {
          this.partDataFor = this.routePackageID;
        }
      } else {
        this.partDataFor = this.routePackageID;
      }
    } else {
      this.partDataFor = this.routePackageID;
    }
    console.log("partDatfor",this.partDataFor)

    this.logbaseService
      .getSupplyInfoData(this.partDataFor)
      .subscribe(result => {
        this.supplyInfoResult = result;
        // Patch the value from response to form field input
        this.supplyInfoForm.patchValue({
          supplierCode: partData.supplierCode,
          partNumber: partData.partNumber,
          partName: partData.partName,
          // supplierNameEng: partData.supplierFirstName + " " + partData.supplierLastName,
          // supplierNameJP: partData.supplierFirstName + " " + partData.supplierLastName,
          supplySpName: this.supplyInfoResult.response.serviceproviderName,
          supplierName: this.supplyInfoResult.response.productionName,
          supplierAddress: this.supplyInfoResult.response
            .prodPointAddrPrefecture,
          supplierCountry: this.supplyInfoResult.response.prodPointAddrCountry,
          supplierCity: this.supplyInfoResult.response.prodPointAddrCity,
          japanZipcode: this.supplyInfoResult.response.prodPointAddrZipCode,
          // otherZipcode: this.supplyInfoResult.response.prodPointAddrZipCode,
          supplierStreet: this.supplyInfoResult.response.prodPointAddrStreet,
          supplierLastName: this.supplyInfoResult.response.contactLastName,
          supplierFirstName: this.supplyInfoResult.response.contactFirstName,
          supplierEmail: this.supplyInfoResult.response.email,
          supplierTelephone: this.supplyInfoResult.response.telephoneNum,
          supplyRegion: this.supplyInfoResult.response.region,
          supplyTransportName: this.supplyInfoResult.response.transportMode,
          supplyContract: this.supplyInfoResult.response.contact
        });

        // this.setValidatorForTransportMode();
        // this.sendSupplyFormData();

        // Create Dynamic shipping point form, which was saved earlier
        if (this.supplyInfoResult.response.shippingList) {
          if (
            this.items.length !=
            this.supplyInfoResult.response.shippingList.length
          ) {
            for (
              let num = 1;
              num < this.supplyInfoResult.response.shippingList.length;
              num++
            ) {
              this.items.push(this.createItem());
            }
          }
        }

        // Bind the form data to dynamically created form.
        if (this.supplyInfoResult.response.shippingList) {
          this.supplyInfoResult.response.shippingList.forEach((item, index) => {
            let splitTime;
            let splitDelTime;
            if (item.deliveryLeadTime) {
              splitTime = item.deliveryLeadTime.split(":");
              splitDelTime = { hour: splitTime[0], minute: splitTime[1] };
            } else {
              splitDelTime = null;
            }
            this.items.controls[eval("index")].patchValue({
              supplyName: item.name,
              supplyAddress: item.shippingPointaddrPrefecture,
              supplyCountry: item.shippingPointaddrCountry,
              supplyCity: item.shippingPointaddrCity,
              supplyJapanZipcode: item.shippingPointaddrZipCode,
              // supplyOtherZipcode: item.shippingPointaddrZipCode,
              supplyStreet: item.shippingPointaddrStreet,
              supplyTimeWindow: item.timeWindowFrom,
              supplySpContact: item.serviceproviderContact,
              supplyDeliveryTime: splitDelTime,
              supplyAsnAvailability: item.isPriorNoticeASNavailable
            });
          });
        }
        this.setValidatorForTransportMode();
        this.sendSupplyFormData();
      this.spinner.hide()});
    this.spinner.hide();
  }

  createFormControls() {
    this.supplyInfoForm = new FormGroup({
      supplierCode: new FormControl({ value: "", disabled: true }),
      partNumber: new FormControl({ value: "", disabled: true }),
      partName: new FormControl({ value: "", disabled: true }),
      supplySpName: new FormControl({ value: "", disabled: false }),
      supplierNameEng: new FormControl({ value: "", disabled: true }),
      supplierName: new FormControl({ value: "", disabled: false }),
      supplierAddress: new FormControl(
        { value: "", disabled: this.productionPrefectureEdit },
        [Validators.required, Validators.maxLength(46)]
      ),
      supplierCountry: new FormControl(
        { value: "", disabled: this.productionCountryEdit },
        Validators.required
      ),
      supplierCity: new FormControl(
        { value: "", disabled: this.productionCityEdit },
        [Validators.required, Validators.maxLength(46)]
      ),
      japanZipcode: new FormControl({
        value: "",
        disabled: this.productionZipEdit
      }),
      // otherZipcode: new FormControl({ value: '', disabled: this.productionZipEdit }, [Validators.required, Validators.maxLength(8)]),
      supplierStreet: new FormControl(
        { value: "", disabled: this.productionStreetEdit },
        [Validators.required, Validators.maxLength(46)]
      ),
      supplierNameJP: new FormControl({ value: "", disabled: true }),
      supplierLastName: new FormControl({ value: "", disabled: false }),
      supplierFirstName: new FormControl({ value: "", disabled: false }),
      supplierEmail: new FormControl({ value: "", disabled: false }),
      supplierTelephone: new FormControl({ value: "", disabled: false }),
      supplyRegion: new FormControl(
        { value: "", disabled: this.regionEdit }
        // Validators.required
      ),
      supplyTransportName: new FormControl({
        value: "",
        disabled: this.transportModeEdit
      }),
      supplyContract: new FormControl(
        { value: "", disabled: this.contractEdit },
        Validators.required
      ),
      items: this.form.array([this.createItem()])
    });
  }

  createItem(item?: any): FormGroup {
    if (!item) {
      return this.form.group({
        supplyName: new FormControl({ value: "", disabled: false }),
        supplyAddress: new FormControl(
          { value: "", disabled: this.shippingPrefectureEdit },
          [Validators.required, Validators.maxLength(46)]
        ),
        supplyCountry: new FormControl(
          { value: "", disabled: this.shippingCountryEdit },
          Validators.required
        ),
        supplyCity: new FormControl(
          { value: "", disabled: this.shippingCityEdit },
          Validators.required
        ),
        supplyJapanZipcode: new FormControl({
          value: "",
          disabled: this.shippingZipEdit
        }),
        // supplyOtherZipcode: new FormControl({ value: '', disabled: this.shippingZipEdit }, [Validators.required, Validators.maxLength(8)]),
        supplyStreet: new FormControl(
          { value: "", disabled: this.shippingStreetEdit },
          [Validators.required, Validators.maxLength(46)]
        ),
        supplyTimeWindow: new FormControl({ value: "", disabled: false }),
        supplySpContact: new FormControl({ value: "", disabled: false }),
        supplyDeliveryTime: new FormControl({ value: "", disabled: false }),
        supplyAsnAvailability: new FormControl({ value: "", disabled: false })
      });
    }
  }

  get items(): FormArray {
    return this.supplyInfoForm.get("items") as FormArray;
  }

  addItem(): void {
    if (this.supplyCounter < 2 && this.items.length < 3) {
      this.items.push(this.createItem());
      this.supplyCounter++;
    } else {
      this.translate
        .get("You cannot add more than 3 Shipping point!")
        .subscribe((res: string) => {
          this.toastr.warning(res);
        });
      // this.toastr.warning("You cannot add more than 3 Shipping point!");
    }
  }

  removeItem(i) {
    this.supplyCounter--;
    this.items.removeAt(i);
  }

  setValidatorForTransportMode() {
    if (this.supplyInfoResult.response.contact == "Supplier-paid") {
      this.supplyInfoForm.get("supplyTransportName").clearValidators();
      this.supplyInfoForm.get("supplyTransportName").updateValueAndValidity();
    } else {
      this.supplyInfoForm.get("supplyTransportName").clearValidators();
      this.supplyInfoForm
        .get("supplyTransportName")
        .setValidators([Validators.required]);
      this.supplyInfoForm.get("supplyTransportName").updateValueAndValidity();
    }
  }

  saveSupplyForm() {
   
    this.spinner.show();

    // To reset Shipping list array
    this.shippingList = [];

    if (this.items.controls["0"] != null) {
      //   if (this.supplyJapanSelected == true) {
      //     this.zipCodeSupply = this.items.get("0")['controls'].supplyJapanZipcode.value
      //   }
      //   else {
      //     this.zipCodeSupply = this.items.get("0")['controls'].supplyOtherZipcode.value
      //   }
      try {
        var delLedTime0 =
          this.items.get("0")['controls'].supplyDeliveryTime.value.hour +
          ":" +
          this.items.get("0")['controls'].supplyDeliveryTime.value.minute;
      } catch (e) {
        console.log("Error happened while saving hours & minutes");
      }
      this.shippingList.push({
        name: this.items.get("0")['controls'].supplyName.value,
        serviceproviderContact: this.items.get("0")['controls']
          .supplySpContact.value,
        deliveryLeadTime: delLedTime0,
        timeWindowFrom: this.items.get("0")['controls'].supplyTimeWindow
          .value,
        isPriorNoticeASNavailable: this.items.get("0")['controls']
          .supplyAsnAvailability.value,
        shippingPointaddrCountry: this.items.get("0")['controls']
          .supplyCountry.value,
        shippingPointaddrPrefecture: this.items.get("0")['controls']
          .supplyAddress.value,
        shippingPointaddrCity: this.items.get("0")['controls'].supplyCity
          .value,
        shippingPointaddrZipCode: this.items.get("0")['controls']
          .supplyJapanZipcode.value,
        shippingPointaddrStreet: this.items.get("0")['controls'].supplyStreet
          .value

        // shippingPointaddrPrefecture: this.detailsAddress["0"].supplyAddress,
        // shippingPointaddrCity: this.detailsAddress["0"].supplyCity,
        // shippingPointaddrStreet: this.detailsAddress["0"].supplyStreet
      });
    }
    if (this.items.controls["1"] != null) {
      //   if (this.supplyJapanSelected == true) {
      //     this.zipCodeSupply = this.items.get("1")['controls'].supplyJapanZipcode.value
      //   }
      //   else {
      //     this.zipCodeSupply = this.items.get("1")['controls'].supplyOtherZipcode.value
      //   }
      if (this.items.get("0")['controls'].supplyDeliveryTime.value != null) {
        var delLedTime1 =
          this.items.get("1")['controls'].supplyDeliveryTime.value.hour +
          ":" +
          this.items.get("1")['controls'].supplyDeliveryTime.value.minute;
      }

      this.shippingList.push({
        name: this.items.get("1")['controls'].supplyName.value,
        serviceproviderContact: this.items.get("1")['controls']
          .supplySpContact.value,
        deliveryLeadTime: delLedTime1,
        timeWindowFrom: this.items.get("1")['controls'].supplyTimeWindow
          .value,
        isPriorNoticeASNavailable: this.items.get("1")['controls']
          .supplyAsnAvailability.value,
        shippingPointaddrCountry: this.items.get("1")['controls']
          .supplyCountry.value,
        shippingPointaddrPrefecture: this.items.get("1")['controls']
          .supplyAddress.value,
        shippingPointaddrCity: this.items.get("1")['controls'].supplyCity
          .value,
        shippingPointaddrZipCode: this.items.get("1")['controls']
          .supplyJapanZipcode.value,
        shippingPointaddrStreet: this.items.get("1")['controls'].supplyStreet
          .value
        // shippingPointaddrPrefecture: this.detailsAddress["1"].supplyAddress,
        // shippingPointaddrCity: this.detailsAddress["1"].supplyCity,
        // shippingPointaddrStreet: this.detailsAddress["1"].supplyStreet
      });
    }
    if (this.items.controls["2"] != null) {
      //   if (this.supplyJapanSelected == true) {
      //     this.zipCodeSupply = this.items.get("2")['controls'].supplyJapanZipcode.value
      //   }
      //   else {
      //     this.zipCodeSupply = this.items.get("2")['controls'].supplyOtherZipcode.value
      //   }
      let delLedTime2 =
        this.items.get("2")['controls'].supplyDeliveryTime.value.hour +
        ":" +
        this.items.get("2")['controls'].supplyDeliveryTime.value.minute;

      this.shippingList.push({
        name: this.items.get("2")['controls'].supplyName.value,
        serviceproviderContact: this.items.get("2")['controls']
          .supplySpContact.value,
        deliveryLeadTime: delLedTime2,
        timeWindowFrom: this.items.get("2")['controls'].supplyTimeWindow
          .value,
        isPriorNoticeASNavailable: this.items.get("2")['controls']
          .supplyAsnAvailability.value,
        shippingPointaddrCountry: this.items.get("2")['controls']
          .supplyCountry.value,
        shippingPointaddrPrefecture: this.items.get("2")['controls']
          .supplyAddress.value,
        shippingPointaddrCity: this.items.get("2")['controls'].supplyCity
          .value,
        shippingPointaddrZipCode: this.items.get("2")['controls']
          .supplyJapanZipcode.value,
        shippingPointaddrStreet: this.items.get("2")['controls'].supplyStreet
          .value
        // shippingPointaddrPrefecture: this.detailsAddress["2"].supplyAddress,
        // shippingPointaddrCity: this.detailsAddress["2"].supplyCity,
        // shippingPointaddrStreet: this.detailsAddress["2"].supplyStreet
      });
    }

    let formDataToSend = {
      packageId: this.partData.packageId,
      productionName: this.supplyInfoForm.get("supplierName").value,
      prodPointAddrCountry: this.supplyInfoForm.get("supplierCountry").value,
      contactFirstName: this.supplyInfoForm.get("supplierFirstName").value,
      contactLastName: this.supplyInfoForm.get("supplierLastName").value,
      email: this.supplyInfoForm.get("supplierEmail").value,
      telephoneNum: this.supplyInfoForm.get("supplierTelephone").value,
      region: this.supplyInfoForm.get("supplyRegion").value,
      contact: this.supplyInfoForm.get("supplyContract").value,
      transportMode: this.supplyInfoForm.get("supplyTransportName").value,
      ProdPointAddrCountry: this.supplyInfoForm.get("supplierCountry").value,
      prodPointAddrPrefecture: this.supplyInfoForm.get("supplierAddress").value,
      prodPointAddrCity: this.supplyInfoForm.get("supplierCity").value,
      prodPointAddrZipCode: this.supplyInfoForm.get("japanZipcode").value,
      prodPointAddrStreet: this.supplyInfoForm.get("supplierStreet").value,
      serviceproviderName: this.supplyInfoForm.get("supplySpName").value,
      shippingList: this.shippingList
    };
    console.log("test123",formDataToSend)

    this.logbaseService
      .saveSupplyFormData(formDataToSend)
      .subscribe(response => {
        // Data copy set to 1 if supply info saved
        let localPartData = localStorage.getItem("copiedPart");
        if (localPartData != "undefined") {
          let copiedPart = JSON.parse(localPartData);

          if (copiedPart != null) {
            this.copiedPartInfo = {
              currentPart: this.routePackageID,
              copyPart: copiedPart.copyPart,
              partInfoSave: copiedPart.partInfoSave,
              supplyInfoSave: 1,
              pkgInfoSave: copiedPart.pkgInfoSave
            };
          }
        }
        localStorage.setItem("copiedPart", JSON.stringify(this.copiedPartInfo));
        this.translate.get("SUPPLY_FORM_SUCCESS").subscribe((res: string) => {
          this.toastr.success(res);
        });
        // Recall get supply information saved data
        this.getSupplyInfoById(this.partData);

        // To reset Shipping list array
        this.shippingList.length = 0;
      });

    // Update status of package from new to inProgress status only by supplier
    if (this.overAllPackageIDStatus != "inProgress") {
      if (this.userRoleId == 1 || this.userRoleId == 9) {
        let statusDataToSend = {
          packStatus: "inProgress",
          packageid: this.partData.packageId,
          updatedBy: this.loginId,
          userRole: this.userRoleId
        };

        this.logbaseService
          .updatePackageStatus(statusDataToSend)
          .subscribe(response => {
            localStorage.setItem("packageOverallStatus", "In Progress");
          });
      }
    }
    this.navigateAfterSave = false;
    this.setValidatorForTransportMode();

    this.sendSupplyFormData();

    console.log("supply info form after save and items",this.supplyInfoForm,this.items)

    this.spinner.hide();
  }

  saveNextSupplyForm() {
    // Save supply info form if user click on "Next" button and navigate to next tab
    // this.setValidatorForTransportMode();
    // this.sendSupplyFormData();
    this.saveSupplyForm();
    localStorage.removeItem("address");
    localStorage.removeItem("address0");
    localStorage.removeItem("address1");
    localStorage.removeItem("address2");
    setTimeout(() => {
      this.router.navigate(["/partDetails/packageInfo/" + this.routePackageID]);
    }, 200);
  }

  //Open History Modal
  openHistoryModal(content) {
    this.modalService.open(content);
  }

  canDeactivate() {
    let lookUp = localStorage.getItem("lookUp");
    if (lookUp == "yes") this.saveNextSupplyForm();
    if (
      (this.supplyInfoForm.dirty && this.navigateAfterSave == true) ||
      (this.items.dirty && this.navigateAfterSave == true)
    ) {
      return this.formDialogService.confirm();
    }
    return true;
  }

  sendSupplyFormData(): void {
    // send message to subscribers via observable subject
    console.log("supplyinfor form",this.supplyInfoForm)
    this.formService.sendSupplyFormData(this.supplyInfoForm);
  }

  japanAutofill(value: any) {
    if (this.supplyInfoForm.get('supplierCountry').value == 'Japan') {
      var postal_code = postalCode;
      var japPrefecture;
      var japCity;
      var japStreet;
      postal_code.get(value, function (address) {
          japPrefecture = address.prefecture;
          japCity = address.city;
          japStreet = address.area;
      })
        this.supplyInfoForm.patchValue({
          supplierAddress: japPrefecture,
          supplierCity: japCity,
          supplierStreet: japStreet
        });
    }
  }

  japanAutofillSupply(value: any) {}

  autoFilled(values, ind) {
    if (values == 1) {
      let zipCode = this.supplyInfoForm.get("japanZipcode").value;
      if (
        this.supplyInfoForm.get("supplierCountry").value == "Japan" &&
        zipCode != undefined
      ) {
        if (!this.checkIsJapanZip(zipCode)) {
          this.getAsyncData(zipCode)
            // Calling resolve in the Promise will get us here, to the first then(…)
            .then(function(address) {
              localStorage.removeItem("address");
              localStorage.setItem("address", JSON.stringify(address));
            })
            // Also if there is an error in any then(..) it will end up here
            .catch(function(error) {
              // Handle error
            });
          this.zipDetailsAddress = JSON.parse(localStorage.getItem("address"));
          this.supplyInfoForm.patchValue({
            supplierAddress: this.zipDetailsAddress
              ? this.zipDetailsAddress.prefecture
              : "",
            supplierCity: this.zipDetailsAddress
              ? this.zipDetailsAddress.city
              : "",
            supplierStreet: this.zipDetailsAddress
              ? this.zipDetailsAddress.area
              : ""
          });
        }
      }
    }

    if (values == 2) {
      let index = String(ind);
      let detailsAddress;
      let zipCode = this.items.controls[index].controls.supplyJapanZipcode
        .value;
      if (
        this.items.controls[index].controls.supplyCountry.value == "Japan" &&
        zipCode != undefined
      ) {
        if (!this.checkIsJapanZip(zipCode)) {
          this.getAsyncData(zipCode)
            // Calling resolve in the Promise will get us here, to the first then(…)
            .then(function(address) {
              localStorage.removeItem("address" + index);
              localStorage.setItem("address" + index, JSON.stringify(address));
            })
            // Also if there is an error in any then(..) it will end up here
            .catch(function(error) {});

          detailsAddress = JSON.parse(localStorage.getItem("address" + index));
          this.detailsAddress[index].supplyCity = detailsAddress
            ? detailsAddress.city
            : "";
          this.detailsAddress[index].supplyAddress = detailsAddress
            ? detailsAddress.prefecture
            : "";
          this.detailsAddress[index].supplyStreet = detailsAddress
            ? detailsAddress.area
            : "";
          this.detailsAddress[index].error = false;

          this.items.controls[eval("ind")].patchValue({
            supplyAddress: this.detailsAddress[index].supplyAddress,
            supplyCity: this.detailsAddress[index].supplyCity,
            supplyStreet: this.detailsAddress[index].supplyStreet
          });
        } else {
          this.detailsAddress[index].error = true;
        }
      }
    }
  }

  getAsyncData(zipCode) {
    if (zipCode != undefined || zipCode != null) {
      return new Promise(function(resolve, reject) {
        let postal_code = postalCode;
        postal_code.get(zipCode, function(address, error) {
          if (error) {
            reject(error);
          } else {
            resolve(address);
          }
        if(zipCode)
          resolve("test")
        else
          reject("error")
        });
      });
    }
  }

  checkIsJapanZip(zipCode: any) {
    if (zipCode != "" && zipCode != undefined && this.regex.test(zipCode)) {
      return false;
    } else {
      return true;
    }
  }

  onContractSelect(value) {
    if (value == "Supplier-paid") {
      this.supplyInfoForm.get("supplyTransportName").clearValidators();
      this.supplyInfoForm.get("supplyTransportName").updateValueAndValidity();
    } else {
      this.supplyInfoForm.get("supplyTransportName").clearValidators();
      this.supplyInfoForm
        .get("supplyTransportName")
        .setValidators([Validators.required]);
      this.supplyInfoForm.get("supplyTransportName").updateValueAndValidity();
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
